import { addDescriptionMapThunk, getMapThunk } from '@redux/features/map.slice';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import Modal from 'Common/Components/Modal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import { useFormik } from 'formik';
import React, { FC, useEffect } from 'react';
import * as Yup from 'yup';

type IProps = {
    show: boolean;
    handleClose: () => void;
    customerId: number | null;
};

const UpdateDescriptionModal: FC<IProps> = ({ show, handleClose, customerId }) => {
    const { loading } = useAppSelector((state: RootState) => state.mapState);
    const dispatch = useAppDispatch();

    const validationSchema = Yup.object({
        description: Yup.string()
            .required('Description is required')
            .min(3, 'Description must be at least 3 characters'),
    });

    const handleSubmit = (values: any) => {
        console.log(values);
        console.log(customerId);
        if (customerId) {
            dispatch(addDescriptionMapThunk({ id: customerId, body: { description: values.description } })).then(
                (res: any) => {
                    if (res.meta.requestStatus === 'fulfilled') {
                        dispatch(getMapThunk());
                        handleClose();
                        formik.resetForm();
                    }
                }
            );
        }
    };

    const formik = useFormik({
        initialValues: {
            description: '',
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        if (!show) {
            formik.resetForm();
        }
    }, [show]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="w-full bg-white p-6 shadow-xl rounded-lg border border-gray-200 overflow-scroll md:w-[550px] md:max-h-[85vh]"
            backdropClassName="backdrop-overlay fixed inset-0 z-[1051] bg-black/70 backdrop-blur-sm"
        >
            <Modal.Header className="border-b border-gray-200 pb-4 mb-4 flex justify-between items-center">
                <Modal.Title className="text-xl font-semibold text-gray-800">Update Customer Description</Modal.Title>
            </Modal.Header>
            <Modal.Body className="my-4">
                <form onSubmit={formik.handleSubmit} className="flex flex-col gap-5">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-3">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            rows={5}
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all resize-none"
                            placeholder="Enter customer description..."
                        />
                        {formik.touched.description && formik.errors.description && (
                            <p className="mt-2 text-sm text-red-600 font-medium">{String(formik.errors.description)}</p>
                        )}
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="flex items-center justify-end gap-3 mt-6 pt-4 border-t border-gray-200">
                <ButtonBase
                    innerText="Cancel"
                    className="bg-gray-500 hover:bg-gray-600 rounded border-none px-4 py-2 text-white"
                    onClick={() => {
                        handleClose();
                        formik.resetForm();
                    }}
                    disabled={loading}
                />
                <ButtonBase
                    innerText="Update Description"
                    className="bg-primary hover:bg-primary-dark rounded border-none px-4 py-2 text-white disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={formik.handleSubmit}
                    disabled={loading || !formik.values.description || !customerId}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateDescriptionModal;
